<div class="grid-container padding-y-4">
  <div class="grid-row">
    <legend class="usa-legend usa-legend--large"
            *ngIf="!this.customerRegistrationForm.get('registrationType').value">
      New Federal Customer Registration</legend>
    <legend class="usa-legend usa-legend--large"
            *ngIf="this.customerRegistrationForm.get('registrationType').value === 'Reporting Official'">
      Agency Authorized Official Registration</legend>
    <legend class="usa-legend usa-legend--large"
            *ngIf="this.customerRegistrationForm.get('registrationType').value === 'User'">
      Agency User Registration</legend>
  </div>
  <form [formGroup]="customerRegistrationForm">
    <fieldset class="usa-fieldset">
      <div class="grid-row">
        <div class="usa-alert usa-alert--success usa-alert--no-icon"
             *ngIf="registrationSuccessful && this.customerRegistrationForm.get('userConfirmation').value ==='No'">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              Your registration request has been received.<br> Please check your email for instructions on
              how to confirm your registration.<br> Click 'Close(X)' to close the browser or click the
              'GSA' logo on the top of this page to go
              to the home page.
            </p>
          </div>
        </div>

        <div class="usa-alert usa-alert--success usa-alert--no-icon"
             *ngIf="registrationSuccessful && this.customerRegistrationForm.get('userConfirmation').value ==='Yes'">
          <div class="usa-alert__body">
            <p class="usa-alert__text">

              Your registration confirmation has been received.<br> Please check your email for confirmation and continue to watch your email for further instructions on your approval request.<br> Click 'Close(X)' to close the browser
              or click the 'GSA' logo on the top of this page to go to the home page.
            </p>
          </div>
        </div>

        <div class="usa-alert usa-alert--error usa-alert--no-icon" *ngIf="registrationFailure">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              An error has occurred during registration. Please contact support at 1 (866) MOVEGSA or
              email to gsamovehelp&#64;gsa.gov.
            </p>
          </div>
        </div>
      </div>

      <!-- Confirming Registration -->
      <div class="grid-row"
           *ngIf="((this.emailPresent !== '') && (this.customerRegistrationForm.get('userConfirmation').value === ''))">
        <fieldset class="usa-fieldset radio-buttons-inline">
          <legend class="usa-legend usa-legend">If you are confirming a Registration you have previously
            requested, select “Yes” below. If this is your initial request to Register for TMSS 2.0, select
            “No” below.
          </legend>
          <div class="usa-radio">
            <input class="usa-radio__input" id="confirm-yes" formControlName="userConfirmation" type="radio"
                   name="userConfirmation" value="Yes" (change)="getConfirmationResponse()" />
            <label class="usa-radio__label" for="confirm-yes">Yes</label>
          </div>
          <div class="usa-radio margin-left-2">
            <input class="usa-radio__input" id="confirm-no" type="radio" name="userConfirmation" value="No"
                   formControlName="userConfirmation" (change)="getConfirmationResponse()" />
            <label class="usa-radio__label" for="confirm-no">No</label>
          </div>
        </fieldset>
      </div>

      <!-- Show when not confirming existing registration -->
      <div class="grid-row grid-gap-0"
           *ngIf="this.customerRegistrationForm.get('userConfirmation').value ==='No' && this.customerRegistrationForm.get('registrationType').value === null">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 ">
          <label for="registration_user_email" class="usa-label">Email<abbr title="required"
                                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="registration_user_email" class="usa-input" formControlName="email"
                 [maxlength]="254">
          <span class="help-text text-muted">Only .gov, .mil, .org or certain .com emails are allowed to
                        register.</span>
          <div
            *ngIf="this.customerRegistrationForm.get('email').invalid && this.customerRegistrationForm.get('email').touched || this.customerRegistrationForm.get('email').dirty">
            <div class="text-danger"
                 *ngIf="this.customerRegistrationForm.get('email').hasError('required')">
              <span class="fa fa-warning"></span> Email is required
            </div>
            <div class="text-danger" *ngIf="this.customerRegistrationForm.get('email').hasError('email')">
              <span class="fa fa-warning"></span> Invalid Email
            </div>
            <div class="text-danger"
                 *ngIf="this.customerRegistrationForm.get('email').hasError('specialEmail')">
              <span class="fa fa-warning"></span> Email not accepted
            </div>
          </div>
          <div class="usa-alert usa-alert--warning" *ngIf="(this.emailPresent)">
            <div class="usa-alert__body">
              <h4 class="usa-alert__heading">Warning status</h4>
              <p class="usa-alert__text">
                An account already exists with this email address. Please login to access your account.
              </p>
            </div>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4 ">
          <label id="registration_user_business_type" class="usa-label">Business Type<abbr title="required"
                                                                                           class="usa-hint usa-hint--required">*</abbr></label>
          <div class="usa-radio">
            <input class="usa-radio__input" formControlName="businessType" id="hhg" type="radio" value="HHG"
                   (click)="onContactTypeChg('HHG')" />
            <label class="usa-radio__label" for="hhg">Household Goods</label>
          </div>
          <div class="usa-radio">
            <input class="usa-radio__input" formControlName="businessType" id="frt" type="radio" value="FRT"
                   (click)="onContactTypeChg('FRT')" />
            <label class="usa-radio__label" for="frt">Freight</label>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
          <button type="button" class="usa-button"
                  [disabled]="this.customerRegistrationForm.get('email').invalid || this.customerRegistrationForm.get('businessType').invalid" (click)="verifyEmail($event)"
                  [value]="emailPresent">Continue
          </button>
          <button type="button" class="usa-button usa-button--outline" (click)='clearPage()'>Cancel</button>
        </div>
      </div>

      <!-- Show when user does not exist in system -->
      <div class="grid-row grid-gap-1"
           *ngIf="((this.emailPresent === false) && this.customerRegistrationForm.get('userConfirmation').value === 'No' && this.customerRegistrationForm.get('registrationType').value === null)">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <legend class="usa-legend usa-legend--medium">Registration Type<abbr title="required"
                                                                               class="usa-hint usa-hint--required">*</abbr></legend>
        </div>
        <div
          class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 radio-buttons-inline">
          <div class="usa-radio">
            <input type="radio" id="registration_type_Reporting_Official" class="usa-radio__input"
                   formControlName="registrationType" name="registrationType" value="Reporting Official"
                   (change)="selectRegisterType()">
            <label class="usa-radio__label" for="registration_type_Reporting_Official">Agency Authorized
              Official</label>
          </div>
          <div class="usa-radio margin-left-2">
            <input type="radio" id="registration_type_User" class="usa-radio__input"
                   formControlName="registrationType" name="registrationType" value="User"
                   (change)="selectRegisterType()">
            <label class="usa-radio__label" for="registration_type_User">Agency User (under an existing
              Authorized Official)</label>
          </div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <label class="usa-label">If you are a supervisor managing employees, please register as an Agency
            Authorized Official. Otherwise register as Agency User</label>
          <div
            *ngIf="this.customerRegistrationForm.get('registrationType').invalid && this.customerRegistrationForm.get('registrationType').touched || this.customerRegistrationForm.get('registrationType').dirty">
            <div class="define-text-secondary"
                 *ngIf="this.customerRegistrationForm.get('registrationType').hasError('required')">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Registration Type is required
            </div>
          </div>
        </div>
      </div>
      <!-- Show when registering new user -->
      <div
        *ngIf="this.customerRegistrationForm.get('userConfirmation').value === 'No' && this.customerRegistrationForm.get('registrationType').value !== null">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label class="usa-label" for="customer_name_new">Agency Name<abbr title="required"
                                                                              class="usa-hint usa-hint--required">*</abbr></label>
            <ng-template #agencySearchTemplate let-model="item" let-index="index">
              {{model.agencyBureauName}} - {{model.agencyCode}}
            </ng-template>
            <input id="customer_name_new" class="usa-input maxw-full" formControlName='agency'
                   placeholder="Select agency" [typeaheadOptionsInScrollableView]="10"
                   [typeaheadOptionsLimit]="300" [typeaheadMinLength]="0"
                   (typeaheadOnSelect)="changeAgency($event)" typeaheadOptionField="agencyBureauName"
                   [typeahead]="agencyMaster" [typeaheadItemTemplate]="agencySearchTemplate"
                   [typeaheadScrollable]="true">
            <div
              *ngIf="this.customerRegistrationForm.get('agencyCode').value === null && this.customerRegistrationForm.get('agencyCode').invalid && this.customerRegistrationForm.get('agencyCode').touched || this.customerRegistrationForm.get('agencyCode').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('agencyCode').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Agency Name is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="bureau_name_new" class="usa-label">Bureau Name<abbr title="required"
                                                                            class="usa-hint usa-hint--required">*</abbr></label>
            <select id="bureau_name_new" class="usa-select maxw-full" formControlName="bureauCode"
                    (change)="changeBureau($event)" name="bureauCode">
              <option value='null' selected disabled>Choose...</option>
              <option *ngFor='let b of bureauMaster' [value]="b.bureauCode">{{b.agencyBureauName}}
                - {{b.bureauCode}} </option>
            </select>
            <div
              *ngIf="this.customerRegistrationForm.get('bureauCode').value === null && this.customerRegistrationForm.get('bureauCode').invalid && this.customerRegistrationForm.get('bureauCode').touched || this.customerRegistrationForm.get('bureauCode').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('bureauCode').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Bureau Name is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
               *ngIf="this.customerRegistrationForm.get('registrationType').value ==='User'">
            <label for="reporting_official_new" class="usa-label">Agency Authorized Official<small
              class="required">*</small></label>
            <select id="reporting_official_new" class="usa-select maxw-full"
                    formControlName="reportingOfficialId" name="reportingOfficialId">
              <option value='null' selected disabled>Choose...</option>
              <option *ngFor='let r of repOfficialList' [value]="r.organizationId">
                {{r.city}},{{r.stateName}}
                - {{r.lastName}}, {{r.firstName}}</option>
            </select>
            <div
              *ngIf="this.customerRegistrationForm.get('reportingOfficialId').invalid && this.customerRegistrationForm.get('reportingOfficialId').touched || this.customerRegistrationForm.get('reportingOfficialId').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('reportingOfficialId').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Authorized Official is required
              </div>
              <div class="define-text-secondary" *ngIf="this.showDropDownMessage">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> No Authorized Official available for the agency and bureau. Contact PMO
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
               *ngIf="this.customerRegistrationForm.get('registrationType').value !=='User'">
            <legend class="usa-legend usa-legend--medium">Permissions<abbr title="required"
                                                                           class="usa-hint usa-hint--required">*</abbr></legend>
            <!--
          <div class="radio-buttons-inline">
            <div class="usa-checkbox">
              <input class="usa-checkbox__input" id="permissions_frt" type="checkbox"
                     formControlName="frtAccess"/>
              <label class="usa-checkbox__label" for="permissions_frt">Freight</label>
            </div>
            <div class="usa-checkbox padding-left-2">
              <input class="usa-checkbox__input" id="permissions_hhg" formControlName="hhgAccess"
                     type="checkbox">
              <label class="usa-checkbox__label" for="permissions_hhg">Household Goods</label>
            </div>
          </div>
          -->
            <div
              class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 radio-buttons-inline">
              <div class="usa-radio margin-right-2" *ngFor="let item of this.permissionRadio">
                <input class="usa-radio__input" id='{{item.key}}' type="radio"
                       formControlName="permissions"
                       name="permissions" value='{{item.key}}' />
                <label class="usa-radio__label" for="{{item.key}}">{{item.text}}</label>
              </div>
            </div>
            <br>
            <small id="fnHelp" class="define-text-secondary" *ngIf="permissionsSelected()">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> Select at least one permission type
            </small>
          </div>
        </div>
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="first_name_new" class="usa-label">First Name<abbr title="required"
                                                                          class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="first_name_new" class="usa-input maxw-full" formControlName="firstName"
                   [maxlength]="35">
            <div
              *ngIf="this.customerRegistrationForm.get('firstName').invalid && this.customerRegistrationForm.get('firstName').touched  || this.customerRegistrationForm.get('firstName').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('firstName').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> First Name is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
                <label for="middle_name_new" class="usa-label">MI</label>
                <input type="text" id="middle_name_new" class="usa-input maxw-full" [maxlength]="1"
                       formControlName="middleInitial">
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
                <label for="last_name_new" class="usa-label">Last Name<abbr title="required"
                                                                            class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="last_name_new" class="usa-input maxw-full"
                       formControlName="lastName" [maxlength]="35">
                <div
                  *ngIf="this.customerRegistrationForm.get('lastName').invalid && this.customerRegistrationForm.get('lastName').touched  || this.customerRegistrationForm.get('lastName').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('lastName').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Last Name is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
                <label for="phone_new" class="usa-label">Phone<abbr title="required"
                                                                    class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="phone_new" class="usa-input maxw-full" [maxlength]="20"
                       formControlName="phone">
                <span class="text-gray-90">Do not include spaces or dashes.</span>
                <div
                  *ngIf="this.customerRegistrationForm.get('phone').invalid && this.customerRegistrationForm.get('phone').touched || this.customerRegistrationForm.get('phone').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('phone').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Phone number is required
                  </div>
                  <div class="define-text-secondaryr"
                       *ngIf="this.customerRegistrationForm.get('phone').hasError('numeric')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Invalid phone number
                  </div>
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('phone').hasError('minlength')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Phone number must be at least 10 digits
                  </div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
                   *ngIf="(this.customerRegistrationForm.get('registrationType').value === 'Reporting Official')">
                <label for="extension_new" class="usa-label">Ext</label>
                <input type="text" id="extension_new" class="maxw-full usa-input" [maxlength]="10"
                       formControlName="phoneExtension">
                <div
                  *ngIf="this.customerRegistrationForm.get('phoneExtension').invalid && this.customerRegistrationForm.get('phoneExtension').touched || this.customerRegistrationForm.get('phoneExtension').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('phoneExtension').hasError('numeric')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Invalid Extension
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="email_new" class="usa-label">Email<abbr title="required"
                                                                class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="email_new" class="maxw-full usa-input" readonly formControlName="email"
                   [maxlength]="254">
            <div
              *ngIf="this.customerRegistrationForm.get('email').invalid && this.customerRegistrationForm.get('email').touched || this.customerRegistrationForm.get('email').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('email').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Email is required
              </div>
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('email').hasError('email')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Invalid Email
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Show for Reporting Officials -->
      <div
        *ngIf="this.customerRegistrationForm.get('userConfirmation').value === 'No' && this.customerRegistrationForm.get('registrationType').value === 'Reporting Official'">
        <div class="grid-row">
          <legend class="usa-legend usa-legend--medium">Agency Authorized Official</legend>
        </div>
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="title_new" class="usa-label">Title<abbr title="required"
                                                                class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="title_new" class="usa-input maxw-full" formControlName="title"
                   [maxlength]="45">
            <div
              *ngIf="this.customerRegistrationForm.get('registrationType').value === 'Reporting Official' && this.customerRegistrationForm.get('title').invalid && this.customerRegistrationForm.get('title').touched || this.customerRegistrationForm.get('title').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('title').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Title is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="country_new" class="usa-label">Country<abbr title="required"
                                                                    class="usa-hint usa-hint--required">*</abbr></label>
            <select id="country_new" class="maxw-full usa-select" formControlName="country" name="country"
                    (change)="onCountryChange()">
              <option value='null' selected disabled>Choose...</option>
              <option *ngFor='let c of countryList' [value]="c.stateCountryId">{{c.stateCountryName}}
              </option>
            </select>
            <div
              *ngIf="this.customerRegistrationForm.get('registrationType').value === 'Reporting Official' && this.customerRegistrationForm.get('country').invalid && this.customerRegistrationForm.get('country').touched || this.customerRegistrationForm.get('country').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('country').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Country is required
              </div>
            </div>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="address_new" class="usa-label">Address 1<abbr title="required"
                                                                      class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="address_new" class="usa-input maxw-full" formControlName="addressLine1"
                   [maxlength]="45">
            <div
              *ngIf="this.customerRegistrationForm.get('registrationType').value === 'Reporting Official' && this.customerRegistrationForm.get('addressLine1').invalid  && this.customerRegistrationForm.get('addressLine1').touched || this.customerRegistrationForm.get('addressLine1').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('addressLine1').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Address is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="address2_new" class="usa-label">Address 2</label>
            <input type="text" id="address2_new" class="maxw-full usa-input" formControlName="addressLine2"
                   [maxlength]="45">
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
               *ngIf="isCountryUsa">
            <ng-template #customItemTemplate let-model="item">{{model.cityName}}, {{model.stateAbbrev}}
              {{model.zipCode}}
            </ng-template>
            <label for="OriginSearchString" class="usa-label">Search by City or Zip: </label>
            <input id="OriginSearchString" class="maxw-full usa-input"
                   formControlName="asyncOriginSearchString" [typeaheadAsync]="true"
                   [typeahead]="dataSourceOrigin" (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
                   (typeaheadOnSelect)="typeaheadOriginOnSelect($event)" typeaheadOptionField="cityName"
                   [typeaheadItemTemplate]="customItemTemplate" [typeaheadWaitMs]="1000"
                   [typeaheadScrollable]="true" [typeaheadOptionsInScrollableView]="10"
                   [typeaheadOptionsLimit]="100" placeholder="Type a location or zip">
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="zip" class="usa-label">Zip Code<abbr title="required"
                                                             class="usa-hint usa-hint--required" *ngIf="this.isCountryUsa">*</abbr></label>
            <input type="text" id="zip" formControlName="zip" id="zip" maxlength="6"
                   class="usa-input maxw-full">
            <div *ngIf="this.customerRegistrationForm.get('zip').hasError('minlength')">
              <small class="define-text-secondary"> <svg class="usa-icon" aria-hidden="true"
                                                         focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
                Zip code should be at least 5 digits long
              </small>
            </div>
            <div *ngIf="this.customerRegistrationForm.get('zip').hasError('numericsOnly')">
              <small class="define-text-secondary"> <svg class="usa-icon" aria-hidden="true"
                                                         focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
                Zip code is invalid - should be all numeric, no dashes, no
                spaces
              </small>
            </div>
            <div *ngIf="this.customerRegistrationForm.get('zip').invalid && (this.customerRegistrationForm.get('zip').touched
                                                       || this.customerRegistrationForm.get('zip').dirty)">
              <small class="define-text-secondary"> <svg class="usa-icon" aria-hidden="true"
                                                         focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
                Zip is required
              </small>
            </div>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="city" class="usa-label">City<abbr title="required"
                                                          class="usa-hint usa-hint--required" *ngIf="this.isCountryUsa">*</abbr></label>
            <input type="text" id="city" formControlName="city" class="usa-input maxw-full" size='45'
                   maxlength='45' id="city">
            <div *ngIf="this.customerRegistrationForm.get('city').invalid && (this.customerRegistrationForm.get('city').touched
                                                         || this.customerRegistrationForm.get('city').dirty)">
              <small class="define-text-secondary"> <svg class="usa-icon" aria-hidden="true"
                                                         focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
                City is required
              </small>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="state" class="usa-label">State<abbr title="required"
                                                            class="usa-hint usa-hint--required" *ngIf="this.isCountryUsa">*</abbr></label>
            <input type="text" id="state" formControlName="state" class="usa-input maxw-full" id="state">
            <div *ngIf="this.customerRegistrationForm.get('state').invalid && (this.customerRegistrationForm.get('state').touched
                                                       || this.customerRegistrationForm.get('state').dirty)">
              <small class="define-text-secondary"> <svg class="usa-icon" aria-hidden="true"
                                                         focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg>
                State is required
              </small>
            </div>
          </div>
        </div>
      </div>
      <!-- Show when confirming existing registration -->
      <div
        *ngIf="this.customerRegistrationForm.get('userConfirmation').value === 'Yes' && this.selectedRegisterId === null">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="registration_id" class="usa-label">Registration Code<abbr title="required"
                                                                                  class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="registration_id" class="usa-input maxw-full"
                   formControlName="userRegisterId" maxlength="35">
            <div
              *ngIf="this.customerRegistrationForm.get('userRegisterId').invalid && this.customerRegistrationForm.get('userRegisterId').touched || this.customerRegistrationForm.get('userRegisterId').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('userRegisterId').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Registration Code is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="registration_id" class="usa-label">Email<abbr title="required"
                                                                      class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="email_id" class="usa-input maxw-full" formControlName="email">
            <div
              *ngIf="this.customerRegistrationForm.get('email').invalid && this.customerRegistrationForm.get('email').touched || this.customerRegistrationForm.get('email').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('email').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Email is required
              </div>
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('email').hasError('email')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Not a valid email
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-top-2">
            <button type="button" class="usa-button"
                    [disabled]="this.customerRegistrationForm.get('userRegisterId').invalid && this.confirmDateValue !== null || this.customerRegistrationForm.get('email').invalid"
                    (click)="getRegistrationDetails()">Continue
            </button>
            <button type="button" class="usa-button usa-button-outline margin-left-2"
                    (click)='clearPage()'>Cancel</button>
          </div>
        </div>
      </div>

      <!-- print error when user confirms -->
      <div
        *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && !this.registrationSuccessful">
        <fieldset class="usa-fieldset">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
              <div class="usa-alert usa-alert--warning usa-alert--no-icon" *ngIf="registrationStatus === 'Confirm Pending'">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    Please review the below registration information and make any needed
                    corrections. Once all is correct, select “Confirm” to complete your registration
                    request or select “Cancel” to go back.
                  </p>
                </div>
              </div>
              <div class="usa-alert usa-alert--error usa-alert--no-icon"
                   *ngIf="registrationStatus === 'Confirmed'">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    User has already confirmed. Please wait for the approval notification.
                  </p>
                </div>
              </div>
              <div class="usa-alert usa-alert--error usa-alert--no-icon" *ngIf="selectedRegisterId === 0">
                <div class="usa-alert__body">
                  <p class="usa-alert__text">
                    Registration ID/Details provided does not exist.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </fieldset>
      </div>

      <!-- Show when registering existing user -->
      <!-- <div> -->
      <div class="grid-row grid-gap-1">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value ==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <label for="registration_type_ext" class="usa-label">Registration Type<abbr title="required"
                                                                                      class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="registration_type_ext" class="usa-input maxw-full" readonly
                 formControlName="registerTypeReadOnly">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <label for="customer_name_ext" class="usa-label">Agency Name<abbr title="required"
                                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="customer_name_ext" class="usa-input maxw-full" readonly
                 formControlName="agencyCodeReadOnly"
                 [value]="this.customerRegistrationForm.get('agencyCodeReadOnly').value">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <label for="bureau_name_ext" class="usa-label">Bureau Name<abbr title="required"
                                                                          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="bureau_name_ext" class="usa-input maxw-full" readonly
                 formControlName="bureauCodeReadOnly"
                 [value]="this.customerRegistrationForm.get('bureauCodeReadOnly').value">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value === 'User' && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <label for="reporting_official_ext" class="usa-label">Authorized Official<abbr title="required"
                                                                                         class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="reporting_official_ext" class="usa-input maxw-full" readonly
                 formControlName="repOfficialReadOnly"
                 [value]="roCitySelected + ', ' + roStateSelected + ' - ' + roLastNameSelected + ', ' + roFirstNameSelected">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <label for="permissions" class="usa-label">Permissions<abbr title="required"
                                                                      class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="permissions" class="maxw-full usa-input" readonly
                 formControlName="permissionReadOnly">
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <label for="first_name_ext" class="usa-label">First Name<abbr title="required"
                                                                        class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="first_name_ext" class="maxw-full usa-input" formControlName="firstName"
                 [maxlength]="35">
          <div
            *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('firstName').invalid && this.customerRegistrationForm.get('firstName').touched || this.customerRegistrationForm.get('firstName').dirty">
            <div class="define-text-secondary"
                 *ngIf="this.customerRegistrationForm.get('firstName').hasError('required')">
              <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
              </svg> First Name is required
            </div>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
              <label for="middle_name_ext" class="usa-label">MI</label>
              <input type="text" id="middle_name_ext" class="maxw-full usa-input" maxlength="1"
                     formControlName="middleInitial" [maxlength]="1">
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
              <label for="last_name_ext" class="usa-label">Last Name<abbr title="required"
                                                                          class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="last_name_ext" class="usa-input maxw-full" formControlName="lastName"
                     [maxlength]="35">
              <div
                *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('lastName').invalid && this.customerRegistrationForm.get('lastName').touched || this.customerRegistrationForm.get('lastName').dirty">
                <div class="define-text-secondary"
                     *ngIf="this.customerRegistrationForm.get('lastName').hasError('required')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Last Name is required
                </div>
              </div>
              <div *ngIf="this.customerRegistrationForm.get('lastName').hasError('pattern')">
                <small class="define-text-secondary"> <svg class="usa-icon" aria-hidden="true"
                                                           focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg>Last Name is invalid.
                </small>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value ==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0 && !this.registrationSuccessful">
          <div class="grid-row grid-gap-1">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
              <label for="phone_ext" class="usa-label">Phone<abbr title="required"
                                                                  class="usa-hint usa-hint--required">*</abbr></label>
              <input type="text" id="phone_ext" class="maxw-full usa-input" maxlength="20"
                     formControlName="phone" [maxlength]="20">
              <span class="text-gray-90">Do not include spaces or dashes.</span>
              <div
                *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('phone').invalid && this.customerRegistrationForm.get('phone').touched || this.customerRegistrationForm.get('phone').dirty">
                <div class="define-text-secondary"
                     *ngIf="this.customerRegistrationForm.get('phone').hasError('required')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Phone is required
                </div>
                <div class="define-text-secondary"
                     *ngIf="this.customerRegistrationForm.get('phone').hasError('numeric')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Invalid phone number
                </div>
                <div class="define-text-secondary"
                     *ngIf="this.customerRegistrationForm.get('phone').hasError('minlength')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Phone number must be at least 10 digits
                </div>
              </div>
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
                 *ngIf="(this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official')">
              <label for="extension_ext" class="usa-label">Ext</label>
              <input type="text" id="extension_ext" class="maxw-full usa-input" [maxlength]="10"
                     formControlName="phoneExtension" [maxlength]="14">
              <div
                *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('phoneExtension').invalid && this.customerRegistrationForm.get('phoneExtension').touched || this.customerRegistrationForm.get('phoneExtension').dirty">
                <div class="define-text-secondary"
                     *ngIf="this.customerRegistrationForm.get('phoneExtension').hasError('numeric')">
                  <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                  </svg> Invalid Extension
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3"
             *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null && this.confirmDateValue=== 0 && this.customerRegistrationForm.get('registerTypeReadOnly').value !== '' && !this.registrationSuccessful">
          <label for="email_ext" class="usa-label">Email<abbr title="required"
                                                              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="email_ext" class="maxw-full usa-input" readonly
                 formControlName="emailReadonly">
        </div>
      </div>

      <!-- Show for Reporting Officials -->
      <div
        *ngIf="this.customerRegistrationForm.get('userConfirmation').value==='Yes' && this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official' && this.confirmDateValue=== 0 && !this.registrationSuccessful">
        <div class="grid-row grid-gap-1">
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
            <legend class="usa-legend usa-legend--medium">Agency Authorized Official</legend>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="title_ext" class="usa-label">Title<abbr title="required"
                                                                class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="title_ext" class="usa-input maxw-full" formControlName="title"
                   [maxlength]="45">
            <div
              *ngIf="this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official' && this.customerRegistrationForm.get('title').invalid && !this.registrationSuccessful && this.customerRegistrationForm.get('title').touched || this.customerRegistrationForm.get('title').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('title').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Title is required
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="address_ext" class="usa-label">Address 1<abbr title="required"
                                                                      class="usa-hint usa-hint--required">*</abbr></label>
            <input type="text" id="address_ext" class="usa-select maxw-full" formControlName="addressLine1"
                   [maxlength]="45">
            <div
              *ngIf="this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official' && this.customerRegistrationForm.get('addressLine1').invalid && !this.registrationSuccessful && this.customerRegistrationForm.get('addressLine1').touched || this.customerRegistrationForm.get('addressLine1').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('addressLine1').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Address is required
              </div>
            </div>
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="address2_ext" class="usa-label">Address 2</label>
            <input type="text" id="address2_ext" class="maxw-full usa-input" formControlName="addressLine2"
                   [maxlength]="45">
          </div>

          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                <label for="zip_ext" class="usa-label">Zip Code<abbr title="required"
                                                                     class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="zip_ext" maxlength="5" class="maxw-full usa-input"
                       formControlName="zip" [maxlength]="5">
                <div
                  *ngIf="this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official' && !this.registrationSuccessful && this.customerRegistrationForm.get('zip').invalid && this.customerRegistrationForm.get('zip').touched || this.customerRegistrationForm.get('zip').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zip').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Zip Code is required
                  </div>
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zip').hasError('numeric')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Invalid Zip Code
                  </div>
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zip').hasError('allZeros')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Zip Code can not be all zeros
                  </div>
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zip').hasError('lengthFive')  && !this.registrationSuccessful && this.customerRegistrationForm.get('country').value ==='US00'">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Zip Code must be 5 characters
                  </div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                <label for="zip_suffix_ext" class="usa-label">ZIP+4</label>
                <input type="text" id="zip_suffix_ext" maxlength="4" class="maxw-full usa-input"
                       formControlName="zipSuffix" [maxlength]="4">
                <div
                  *ngIf="this.customerRegistrationForm.get('registrationType').value === 'Reporting Official' && this.customerRegistrationForm.get('zipSuffix').invalid && !this.registrationSuccessful && this.customerRegistrationForm.get('zipSuffix').touched || this.customerRegistrationForm.get('zipSuffix').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zipSuffix').hasError('numeric')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> Invalid ZIP+4
                  </div>
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zip').hasError('allZeros')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> ZIP+4 can not be all zeros
                  </div>
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('zip').hasError('lengthFour') && this.customerRegistrationForm.get('country').value==='US00'">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> ZIP+4 must be 4 characters
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <div class="grid-row grid-gap-1">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                <label for="city_ext" class="usa-label">City<abbr title="required"
                                                                  class="usa-hint usa-hint--required">*</abbr></label>
                <input type="text" id="city_ext" class="maxw-full usa-input" formControlName="city"
                       [maxlength]="45">
                <div
                  *ngIf="this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official' && !this.registrationSuccessful && this.customerRegistrationForm.get('city').invalid  && this.customerRegistrationForm.get('city').touched || this.customerRegistrationForm.get('city').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('city').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> City is required
                  </div>
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                <label for="state_ext" class="usa-label">State<abbr title="required"
                                                                    class="usa-hint usa-hint--required">*</abbr></label>
                <select id="state_ext" class="usa-select maxw-full" formControlName="state"
                        name="state">
                  <option [value]='null' selected disabled>Choose...</option>
                  <option *ngFor='let s of stateList' [value]="s.stateCountryId">
                    {{s.stateCountryName}}</option>
                </select>
                <div
                  *ngIf="this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official'  && !this.registrationSuccessful && this.customerRegistrationForm.get('state').invalid && this.customerRegistrationForm.get('state').touched || this.customerRegistrationForm.get('state').dirty">
                  <div class="define-text-secondary"
                       *ngIf="this.customerRegistrationForm.get('state').hasError('required')">
                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                      <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                    </svg> State is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
            <label for="country_ext" class="usa-label">Country<abbr title="required"
                                                                    class="usa-hint usa-hint--required">*</abbr></label>
            <select id="country_ext" class="maxw-full usa-select" formControlName="country" name="country">
              <option [value]='null' selected disabled>Choose...</option>
              <option *ngFor='let c of countryList' [value]="c.stateCountryId">{{c.stateCountryName}}
              </option>
            </select>
            <div
              *ngIf="this.customerRegistrationForm.get('registerTypeReadOnly').value === 'Reporting Official'  && !this.registrationSuccessful && this.customerRegistrationForm.get('country').invalid && this.customerRegistrationForm.get('country').touched || this.customerRegistrationForm.get('country').dirty">
              <div class="define-text-secondary"
                   *ngIf="this.customerRegistrationForm.get('country').hasError('required')">
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                </svg> Country is required
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Show when confirming registrations -->
      <div class="padding-top-1"
           *ngIf="this.customerRegistrationForm.get('userConfirmation').value ==='Yes' && !this.registrationSuccessful && this.customerRegistrationForm.get('registerTypeReadOnly').value !== null  && this.confirmDateValue === 0 && this.selectedRegisterId !== null && this.selectedRegisterId !== 0">
        <button type="button" class="usa-button"
                [disabled]="((this.customerRegistrationForm.invalid) || (this.registrationSuccessful))"
                (click)='confirmCustomer(this.customerRegistrationForm.value)'>Confirm</button>
        <button type="button" class="usa-button usa-button--outline margin-left-2"
                (click)='clearPage()'>Cancel</button>
      </div>
      <!-- Show for new registrations -->
      <div class="padding-top-1"
           *ngIf="this.customerRegistrationForm.get('userConfirmation').value ==='No' && this.customerRegistrationForm.get('registrationType').value !== null">
        <button type="button" class="usa-button"
                [disabled]="this.customerRegistrationForm.invalid || this.registrationSuccessful || permissionsSelected()"
                (click)='registerCustomer(this.customerRegistrationForm.value)'>Submit</button>
        <button type="button" class="usa-button usa-button--outline margin-left-2"
                (click)='clearPage()'>Cancel</button>
      </div>
    </fieldset>
  </form>
</div>
